export default "__VITE_ASSET__CyjVOkde__"